import { respondTo } from '@ad-lucy/styled';
import styled from 'styled-components';

export const StyledMusicIcon = styled.svg`
  ${respondTo.DOOH`
    width: 1.5rem;
    height: 1.5rem;
  `}
`;
